import { SET_PAGE_TITLE } from '../types';

export default {
	namespaced: true,

	state: {
		title: '',
		isShow: false,
	},

	mutations: {
		[SET_PAGE_TITLE](state, config) {
			state.title = config.title;
			state.isShow = config.isShow;
		},
	},

	actions: {
		setPageTitle({ commit }, config) {
			commit(SET_PAGE_TITLE, config);
		},
	},
};
